import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject }    from 'rxjs/Subject';

import { CourtCase } from './court-case';

@Injectable()
export class EventService {

  // Observable source
  private clearHistorySource            = new Subject<any>();
  private impendingSessionTimeoutSource = new Subject<any>();
  private focusFieldSource              = new Subject<string>();
  private openHelpSource                = new Subject<any>();
  private openAboutSource               = new Subject<any>();
  private openEmailSource               = new Subject<CourtCase[]>();
  private openPrintSource               = new Subject<CourtCase[]>();
  private openClearHistorySource        = new Subject<any>();
  private openDisclaimerSource          = new Subject<string>();
  private otherDataLoadedSource         = new Subject<any>();
  private sessionTimedOutSource         = new Subject<void>();
  private bondsmanDetailsLoadedSource   = new Subject<any>();

  // Observable stream
  clearHistoryRequested$: Observable<any>           = this.clearHistorySource.asObservable();
  impendingSessionTimeoutDetected$: Observable<any> = this.impendingSessionTimeoutSource.asObservable();
  focusFieldRequested$: Observable<any>             = this.focusFieldSource.asObservable();
  openHelpRequested$: Observable<any>               = this.openHelpSource.asObservable();
  openAboutRequested$: Observable<any>              = this.openAboutSource.asObservable();
  openEmailRequested$: Observable<CourtCase[]>              = this.openEmailSource.asObservable();
  openPrintRequested$: Observable<CourtCase[]>              = this.openPrintSource.asObservable(); // TODO: data type
  openClearHistoryRequested$: Observable<any>       = this.openClearHistorySource.asObservable();
  openDisclaimerRequest$: Observable<string>           = this.openDisclaimerSource.asObservable();
  otherDataLoaded$: Observable<any>                 = this.otherDataLoadedSource.asObservable();
  sessionTimedOut$: Observable<void>           = this.sessionTimedOutSource.asObservable();
  bondsmanDetailsLoaded$: Observable<any>      = this.bondsmanDetailsLoadedSource.asObservable();

  constructor() { }

  // Service commands
  clearHistory() {
     this.clearHistorySource.next();
  }

  notifyOfImpendingSessionTimeout() {
     this.impendingSessionTimeoutSource.next();
  }

  focusField(id: string) {
     this.focusFieldSource.next(id);
  }

  openHelp() {
     this.openHelpSource.next();
  }

  openAbout() {
     this.openAboutSource.next();
  }

  openEmail(cases: CourtCase[]) {
     this.openEmailSource.next(cases);
  }

  openPrint(cases: CourtCase[]) {
     this.openPrintSource.next(cases);
  }

  openClearHistory() {
    this.openClearHistorySource.next();
  }

  openDisclaimer(mode?: string) {
    this.openDisclaimerSource.next(mode);
  }

  otherDataLoaded() {
    this.otherDataLoadedSource.next();
  }

  sessionTimedOut() {
    this.sessionTimedOutSource.next();
  }

  bondsmanDetailsLoaded() {
    this.bondsmanDetailsLoadedSource.next();
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/event.service.ts